import { ScrollShadow, Skeleton } from "@heroui/react";
import { useFormContext } from "react-hook-form";

import { StyledNumberDisplay } from "../styled-number-display";
import { AssetImage } from "../AssetImage";
import type { TokenDetails } from "../../types/token.types";

const SelectTokenItem = ({
  token,
  onClick,
}: {
  token: TokenDetails;
  onClick: () => void;
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex space-x-3 items-center hover:bg-content2 rounded-md w-full px-4 py-2 text-left"
    >
      <AssetImage identifier={token.identifier} className="w-10 h-10" />
      <div className="flex flex-col items-start">
        <p className="text-lg text-black dark:text-white">
          {token.identifier.split("-")[0]}
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {token.identifier}
        </p>
      </div>
    </button>
  );
};

interface Props {
  tokens: TokenDetails[];
  name: string;
  onClick: () => void;
}

export const SelectableTokenList = ({ tokens, name, onClick }: Props) => {
  const form = useFormContext();

  const onSelect = (token: TokenDetails) => {
    console.log("selecting", name, token);
    form.setValue(name, token);
    onClick();
  };

  return (
    <ScrollShadow hideScrollBar className="h-[400px] space-y-1">
      {tokens.length !== 0 ? (
        tokens.map((token) => (
          <SelectTokenItem
            onClick={() => onSelect(token)}
            key={token.identifier}
            token={token}
          />
        ))
      ) : (
        <div className="flex items-center justify-center h-32 text-gray-500 dark:text-gray-400">
          No tokens found.
        </div>
      )}
    </ScrollShadow>
  );
};
